import { useState } from "react";
import UDocViewer from "./UDocViewer";

const TextViewer = ({ src }) => {
  const [useFallback, setUseFallback] = useState(false);

  if (useFallback) {
    return (
      <div>
        <iframe
          title="Document Viewer"
          src={`https://docs.google.com/viewer?url=${src}&efh=false&a=v&chrome=false&embedded=true`}
          style={{ width: "100%", height: "70vh" }}
          sandbox="allow-same-origin allow-scripts allow-forms"
        ></iframe>
        <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "80%", opacity: 0 }}></div>
      </div>
    );
  }

  return (
    <div style={{ width: "100%", height: "70vh" }}>
      <UDocViewer src={src} onError={() => setUseFallback(true)} />
    </div>
  );
};

export default TextViewer;
